import { render, staticRenderFns } from "./HighlightedUrl.vue?vue&type=template&id=2caa6308&scoped=true&"
import script from "./HighlightedUrl.vue?vue&type=script&lang=js&"
export * from "./HighlightedUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa6308",
  null
  
)

export default component.exports